import * as THREE from "three";

export const CarbonFiber = () => {
  const cfTexture = new THREE.TextureLoader().load("/textures/cf_1k.png");
  return <meshStandardMaterial color="black" roughnessMap={cfTexture} />;
};
